var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyPetMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1189,
    height: 310,
    viewBox: "0 0 1189 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.62 228.28H236.88V233.31H240.49V287.33H441.01V260.91L552.36 260.81L572.47 295.38H592.87V288.47L595.13 288.07V295.38H616.22V257.36V227.38L253.62 228.28Z",
    fill: "#E8DFD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368.49 239.08H287.33V274.91H368.49V239.08Z",
    fill: "#BFB8AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512.52 244.2H499.36V251.51H512.52V244.2Z",
    fill: "#BFB8AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.13 288.8H243.46V295.38H266.13V288.8Z",
    fill: "#855914"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.93 295.38H245.65V298.3H263.93V295.38Z",
    fill: "#2B2A25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.26 288.8H267.59V295.38H290.26V288.8Z",
    fill: "#855914"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288.06 295.38H269.78V298.3H288.06V295.38Z",
    fill: "#2B2A25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M437.95 287.33H415.28V293.91H437.95V287.33Z",
    fill: "#855914"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M435.75 293.92H417.47V296.84H435.75V293.92Z",
    fill: "#2B2A25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M592.95 287.33H570.28V293.91H592.95V287.33Z",
    fill: "#855914"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M590.75 293.92H572.47V296.84H590.75V293.92Z",
    fill: "#2B2A25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M615.61 287.33H592.94V293.91H615.61V287.33Z",
    fill: "#855914"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M613.41 293.92H595.13V296.84H613.41V293.92Z",
    fill: "#2B2A25"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M511.97 94.4014H494.697V171.194H511.97V94.4014Z",
    fill: "#A8ACAD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 101.749H459.362C461.172 101.749 462.647 103.226 462.647 105.04V116.027C462.647 117.841 461.172 119.318 459.362 119.318H455.889V101.735V101.749Z",
    fill: "#BB716A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 123.214H459.362C461.172 123.214 462.647 124.691 462.647 126.505V137.492C462.647 139.306 461.172 140.783 459.362 140.783H455.889V123.2V123.214Z",
    fill: "#BB716A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M529.242 94.4014H511.97V171.194H529.242V94.4014Z",
    fill: "#89A4A6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M529.242 89.3379H427.58V94.4019H529.242V89.3379Z",
    fill: "#89A4A6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M529.242 171.194H427.58V176.258H529.242V171.194Z",
    fill: "#89A4A6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 144.678H459.362C461.172 144.678 462.647 146.156 462.647 147.969V158.957C462.647 160.77 461.172 162.248 459.362 162.248H455.889V144.665V144.678Z",
    fill: "#BB716A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 95.0059H430.557V171.799H455.889V95.0059Z",
    fill: "#A8ACAD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M340.616 91.875V176.257H432.153V91.875H340.616ZM391.628 142.797L372.317 156.606C367.235 160.246 360.664 162.274 353.865 162.274V106.207C356.185 104.998 358.826 104.394 361.468 104.394C364.606 104.394 367.731 105.254 370.292 106.919L391.628 120.875V142.797Z",
    fill: "#3E4651"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M429.31 94.4012H366.162L364.418 87H429.31V94.4012Z",
    fill: "#28313E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M429.31 177.427H366.162L364.418 170.025H429.31V177.427Z",
    fill: "#28313E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5 109.606H279.197C282.603 109.606 285.366 112.374 285.366 115.785V151.972C285.366 155.384 282.603 158.151 279.197 158.151H278.5V109.606Z",
    fill: "#28313E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M341.93 128.426H285.366V139.749H341.93V128.426Z",
    fill: "#3E4651"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M549.5 158.151L548.803 158.151C545.397 158.151 542.634 155.384 542.634 151.972L542.634 115.786C542.634 112.374 545.397 109.607 548.803 109.607L549.5 109.607L549.5 158.151Z",
    fill: "#28313E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M529.228 138.378L543.615 138.378L543.615 128.102L529.228 128.102L529.228 138.378Z",
    fill: "#3E4651"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M323.008 123.375H370.48C375.495 123.375 379.572 127.458 379.572 132.482C379.572 137.506 375.495 141.589 370.48 141.589H323.008V123.375Z",
    fill: "#2B323B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4490_4426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9721 63.51V73.75H17.8321V63.51H19.8221V57.88H16.8921V56.25H20.1421V51.85H16.2721L16.1621 49.62H19.8021L19.8221 44.5H16.4821L16.1621 43.04H19.8221V35H11.9321V42.72L13.9721 43.04V44.5L11.9321 44.35V49.44L13.2421 49.62V51.82L11.9321 51.4L11.7821 56.2H13.2421V57.67L11.7821 57.71V63.54L13.9721 63.51Z",
    fill: "#E4E2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.482 73.75H0.812134V296.01H178.482V73.75Z",
    fill: "#E4E2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.402 78.87L205.532 81.79V78.64L178.482 73.75V78.36L181.402 78.87Z",
    fill: "#FB8B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.482 78.3604V296.01L204.802 278.47L205.532 81.7904L178.482 78.3604Z",
    fill: "#FB8B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.532 81.7902V80.7502L178.482 77.4102V78.8702L205.532 81.7902Z",
    fill: "#57461B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.972 79.5996H13.5721V290.83H167.972V79.5996Z",
    stroke: "#855914",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5721 165.75H129.852V225.61H13.5721",
    stroke: "#855914",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.852 79.5996V290.83",
    stroke: "#855914",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6321 301.86H33.7121V304.78H36.6321V301.86Z",
    fill: "#5E4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6321 305.52H33.7121V308.44H36.6321V305.52Z",
    fill: "#5E4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5621 297.11H30.7921V302.23H39.5621V297.11Z",
    fill: "#5E4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6321 301.86H33.7121V304.78H36.6321V301.86Z",
    fill: "#5E4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9221 304.79H30.4221C29.0083 304.79 27.8621 305.936 27.8621 307.35C27.8621 308.764 29.0083 309.91 30.4221 309.91H39.9221C41.336 309.91 42.4821 308.764 42.4821 307.35C42.4821 305.936 41.336 304.79 39.9221 304.79Z",
    fill: "#5E4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.422 297.11H142.652V302.23H151.422V297.11Z",
    fill: "#5E4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.492 301.86H145.572V304.78H148.492V301.86Z",
    fill: "#5E4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.792 304.79H142.292C140.878 304.79 139.732 305.936 139.732 307.35C139.732 308.764 140.878 309.91 142.292 309.91H151.792C153.206 309.91 154.352 308.764 154.352 307.35C154.352 305.936 153.206 304.79 151.792 304.79Z",
    fill: "#5E4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 176.84H25.6721V180.5H62.9621V176.84Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 181.64H25.6721V185.3H62.9621V181.64Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 186.45H25.6721V190.11H62.9621V186.45Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 191.25H25.6721V194.91H62.9621V191.25Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 196.06H25.6721V199.72H62.9621V196.06Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 200.859H25.6721V204.519H62.9621V200.859Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 205.67H25.6721V209.33H62.9621V205.67Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 210.47H25.6721V214.13H62.9621V210.47Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 176.84H81.9721V180.5H119.262V176.84Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 181.64H81.9721V185.3H119.262V181.64Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 186.45H81.9721V190.11H119.262V186.45Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 191.25H81.9721V194.91H119.262V191.25Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 196.06H81.9721V199.72H119.262V196.06Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 200.859H81.9721V204.519H119.262V200.859Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 205.67H81.9721V209.33H119.262V205.67Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 210.47H81.9721V214.13H119.262V210.47Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 240.45H81.9721V244.11H119.262V240.45Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 245.25H81.9721V248.91H119.262V245.25Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 250.061H81.9721V253.721H119.262V250.061Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 254.86H81.9721V258.52H119.262V254.86Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 259.67H81.9721V263.33H119.262V259.67Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 264.47H81.9721V268.13H119.262V264.47Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 269.28H81.9721V272.94H119.262V269.28Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 274.08H81.9721V277.74H119.262V274.08Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 240.45H25.6721V244.11H62.9621V240.45Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 245.25H25.6721V248.91H62.9621V245.25Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 250.061H25.6721V253.721H62.9621V250.061Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 254.86H25.6721V258.52H62.9621V254.86Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 259.67H25.6721V263.33H62.9621V259.67Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 264.47H25.6721V268.13H62.9621V264.47Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 269.28H25.6721V272.94H62.9621V269.28Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9621 274.08H25.6721V277.74H62.9621V274.08Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.152 117.98C186.152 117.98 211.742 112.13 204.432 176.47C197.122 240.81 187.612 259.82 224.172 237.89C232.942 232.04 235.502 229.77 235.502 229.77",
    stroke: "url(#paint0_linear_4490_4426)",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.962 139.12C183.962 139.12 196.662 136.22 193.032 168.15C189.402 200.08 184.682 209.52 202.832 198.63C207.182 195.73 208.452 194.6 208.452 194.6",
    stroke: "#855914",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.152 122.37C187.362 122.37 188.342 120.404 188.342 117.98C188.342 115.555 187.362 113.59 186.152 113.59C184.943 113.59 183.962 115.555 183.962 117.98C183.962 120.404 184.943 122.37 186.152 122.37Z",
    fill: "#855914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.322 140.28C184.725 140.28 185.052 139.627 185.052 138.82C185.052 138.014 184.725 137.36 184.322 137.36C183.919 137.36 183.592 138.014 183.592 138.82C183.592 139.627 183.919 140.28 184.322 140.28Z",
    fill: "#855914"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M220.79 0V36.56H635.34V0H220.79ZM628.77 32.17H227.38V4.39H628.77V32.17Z",
    fill: "#FB8B24"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M223.72 38.71V49.72H211.22L209.82 208.38H223.71V222.44H388.95V232.15H579.04V38.71H223.71H223.72ZM326.81 212.03H277.82V53.3699H326.81V212.03ZM383.11 210.57H338.51V53.38H383.11V210.57ZM468.65 220.07H394.81V46.06H468.65V220.07ZM550.54 220.07H476.7V46.06H550.54V220.07Z",
    fill: "#FB8B24"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M635.34 38.75H581.24V232.5H635.34V38.75Z",
    fill: "#FB8B24"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M577.59 41.6699H557.12V226.65H577.59V41.6699Z",
    fill: "#FB8B24"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M349.48 4.38965H345.09V32.1696H349.48V4.38965Z",
    fill: "#FB8B24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M501.55 4.38965H497.16V32.1696H501.55V4.38965Z",
    fill: "#FB8B24"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M583.44 4.38965H579.05V32.1696H583.44V4.38965Z",
    fill: "#FB8B24"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M635.35 62.5703H663.25L666.05 68.0003V97.2403H677.39V149.88L663.3 158.29L635.98 159.39L635.35 62.5703Z",
    fill: "#FB8B24"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M663.13 116.25H652.89V122.83H663.13V116.25Z",
    fill: "#231F20",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M990.11 168.161H845.18V96.5107H1025.04L990.11 168.161Z",
    fill: "#383D3D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M972.39 70.1904H666.05V73.1104H972.39V70.1904Z",
    fill: "#5D5E61"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M781.75 118.631H753.97V151.531H781.75V118.631Z",
    fill: "url(#paint1_linear_4490_4426)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M767.86 131.791L764.07 138.371H771.66L767.86 131.791L764.07 138.371H771.66L767.86 131.791Z",
    fill: "#FFF200"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M796.19 168.16H639.73V251.51H796.19V168.16Z",
    fill: "#9EACAC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M796.2 293.92L761.1 280.02L755.98 249.32H796.2V293.92Z",
    fill: "#E9E2D6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.58 168.16H796.2V293.91H1178.58V168.16Z",
    fill: "#9EACAC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M820.33 293.921H797.66V300.501H820.33V293.921Z",
    fill: "#855914"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M818.13 300.501H799.85V303.421H818.13V300.501Z",
    fill: "#2B2A25"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.38 293.921H979.71V300.501H1002.38V293.921Z",
    fill: "#855914"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.18 300.501H981.9V303.421H1000.18V300.501Z",
    fill: "#2B2A25"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 293.921H1145.68V300.501H1168.35V293.921Z",
    fill: "#855914"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.15 300.501H1147.87V303.421H1166.15V300.501Z",
    fill: "#2B2A25"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M927.07 176.931H810.09V288.061H927.07V176.931Z",
    fill: "#E8E4D9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M995.8 176.931H932.19V288.061H995.8V176.931Z",
    fill: "#E8E4D9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.79 176.931H1000.18V288.061H1063.79V176.931Z",
    fill: "#E8E4D9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 176.931H1068.18V288.061H1168.35V176.931Z",
    fill: "#E8E4D9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M873.5 222.261L863.79 239.081H883.21L873.5 222.261L863.79 239.081H883.21L873.5 222.261Z",
    fill: "#3385AE"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M967.09 222.261L957.38 239.081H976.79L967.09 222.261L957.38 239.081H976.79L967.09 222.261Z",
    fill: "#3385AE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.08 222.261L1025.37 239.081H1044.79L1035.08 222.261L1025.37 239.081H1044.79L1035.08 222.261Z",
    fill: "#3385AE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.62 222.261L1110.91 239.081H1130.33L1120.62 222.261L1110.91 239.081H1130.33L1120.62 222.261Z",
    fill: "#3385AE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.58 185.28L1188.81 188.63V253.1H1178.58V185.28Z",
    fill: "#E8E4D9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M669.34 66.9004L972.76 69.8204V96.5304H771.16L770.24 105.65H779.58L779.05 116.25H783.1L784.13 154.63H755.33L749.04 153.17V138.55L677.39 139.87V97.2404H666.05V68.0004L669.34 66.9004Z",
    fill: "url(#paint2_linear_4490_4426)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M712.85 108.57H677.02V112.96H712.85V108.57Z",
    fill: "#231F20"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M777.5 105.65H708.88C707.842 105.65 707 106.492 707 107.53V114.01C707 115.049 707.842 115.89 708.88 115.89H777.5C778.538 115.89 779.38 115.049 779.38 114.01V107.53C779.38 106.492 778.538 105.65 777.5 105.65Z",
    fill: "#231F20"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M910.98 69.2108V67.2708C910.98 63.6408 913.93 60.6908 917.56 60.6908V56.6708C917.56 55.6608 918.38 54.8408 919.39 54.8408C920.4 54.8408 921.22 55.6608 921.22 56.6708V60.6908C924.45 60.6908 927.07 63.3108 927.07 66.5408V69.4008L910.99 69.2208L910.98 69.2108Z",
    fill: "#3E99D2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M930.72 69.2802V67.3401C930.72 63.7101 933.67 60.7601 937.3 60.7601V56.7402C937.3 55.7302 938.12 54.9102 939.13 54.9102C940.14 54.9102 940.96 55.7302 940.96 56.7402V60.7601C944.19 60.7601 946.81 63.3802 946.81 66.6102V69.4702L930.73 69.2901L930.72 69.2802Z",
    fill: "#3E99D2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M949.73 70.0106V68.0706C949.73 64.4406 952.68 61.4906 956.31 61.4906V57.4706C956.31 56.4606 957.13 55.6406 958.14 55.6406C959.15 55.6406 959.97 56.4606 959.97 57.4706V61.4906C963.2 61.4906 965.82 64.1106 965.82 67.3406V70.2006L949.74 70.0206L949.73 70.0106Z",
    fill: "#3E99D2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M990.86 101.811H963.08V134.711H990.86V101.811Z",
    fill: "url(#paint3_linear_4490_4426)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M976.97 114.971L973.17 121.551H980.77L976.97 114.971L973.17 121.551H980.77L976.97 114.971Z",
    fill: "#FFF200"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M983.15 73.1301C982.18 73.1901 981.26 73.4601 980.44 73.8901V73.1201H983.15V73.1301Z",
    fill: "url(#paint4_linear_4490_4426)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.02 94.3004C1014.87 94.3004 1014.73 94.3104 1014.59 94.3104H980.45V93.6504C981.17 93.9604 981.96 94.1304 982.78 94.1304L1015.02 94.3004Z",
    fill: "url(#paint5_linear_4490_4426)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.38 79.2801V87.5101C1021.38 90.1301 1019.9 92.4001 1017.72 93.5401C1016.9 93.9601 1015.98 94.2301 1015.01 94.2901L982.77 94.1201C981.94 94.1201 981.15 93.9501 980.44 93.6401C978.29 92.7301 976.78 90.6101 976.78 88.1301V79.9001C976.78 77.2801 978.26 75.0101 980.44 73.8801C981.26 73.4501 982.18 73.1801 983.15 73.1201L1015.39 73.2901C1016.22 73.2901 1017.01 73.4601 1017.72 73.7701C1019.87 74.6801 1021.38 76.8001 1021.38 79.2801Z",
    fill: "url(#paint6_linear_4490_4426)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.73 73.1104V73.7704C1017.01 73.4604 1016.22 73.2903 1015.4 73.2903L983.16 73.1203C983.31 73.1203 983.45 73.1104 983.59 73.1104H1017.73Z",
    fill: "url(#paint7_linear_4490_4426)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.02 94.3008C1015.99 94.2408 1016.91 93.9708 1017.73 93.5508V94.3208H1015.02V94.3008Z",
    fill: "url(#paint8_linear_4490_4426)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M791.289 113.01H827.705C837.28 113.01 841.812 118.691 841.812 125.689C841.812 131.38 835.492 136 827.705 136H794.476C788.586 136 783.812 132.511 783.812 128.206V118.475C783.812 115.457 787.174 113 791.303 113L791.289 113.01Z",
    fill: "url(#paint9_linear_4490_4426)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M808.62 140.38H839.812C839.812 140.38 852.632 123.78 838.312 110.77C827.952 109.62 796.19 110.77 796.19 110.77L797.35 105.65H770.23L771.15 96.5303H852.17V101.38L861.25 101.63C861.25 101.63 864.29 103.09 864.23 110.77C864.17 118.45 864.23 142.32 864.23 142.32C864.23 142.32 864.94 148.42 857.59 148.42C854.67 148.42 856.13 172.55 856.13 172.55H790.39L764.04 166.44L647.02 165.97L635.95 159.39L663.47 160.21L677.36 149.88V139.87L749.01 138.55L750.11 153.54L767.66 154.27L783.74 155V144.76L808.6 140.37L808.62 140.38Z",
    fill: "#E9E2D6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M899.65 105.28H867.48C865.663 105.28 864.19 106.753 864.19 108.57C864.19 110.387 865.663 111.86 867.48 111.86H899.65C901.467 111.86 902.94 110.387 902.94 108.57C902.94 106.753 901.467 105.28 899.65 105.28Z",
    fill: "url(#paint10_linear_4490_4426)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M899.65 138.181H867.48C865.663 138.181 864.19 139.654 864.19 141.471C864.19 143.288 865.663 144.761 867.48 144.761H899.65C901.467 144.761 902.94 143.288 902.94 141.471C902.94 139.654 901.467 138.181 899.65 138.181Z",
    fill: "url(#paint11_linear_4490_4426)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M862.73 111.86H892.38C897.4 111.86 901.48 115.94 901.48 120.96V129.08C901.48 134.1 897.4 138.18 892.38 138.18H862.73V111.86Z",
    fill: "url(#paint12_linear_4490_4426)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M897.09 103.09H920.18C920.18 103.09 927.07 108.94 919.02 114.3C919.02 114.36 919.01 114.42 919 114.48C918.73 116.81 920.01 118.93 921.98 119.87C923.38 120.54 924.2 122.01 924.14 123.56C924.14 126.39 921.85 128.68 919.02 128.68C919.02 128.68 916.83 133.08 918.29 135.99C919.75 138.9 925.44 143.3 920.4 144.76C915.36 146.22 897.09 146.22 897.09 146.22V103.08V103.09Z",
    fill: "#E9E2D6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M977.52 82.6201H973.13V85.5401H977.52V82.6201Z",
    fill: "url(#paint13_linear_4490_4426)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.04 96.5107L990.11 168.161H1114.98L1139.57 121.551H1019.19L1030.53 96.5107H1025.04Z",
    fill: "#E8E4D9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.22 71.6504C1008.22 71.6504 1028.69 69.7504 1021.38 87.5204C1020.65 90.8804 1012.86 96.5104 1012.86 96.5104H1030.53L1045.57 85.5404L1046.85 66.9004H1006.47L1002.07 71.6504H1008.23H1008.22Z",
    fill: "#E9E2D6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.68 53.3704L1137.02 49.1904H1021.39L1006.77 67.2604C1006.77 67.2604 1033.09 67.2604 1041.13 66.8904C1049.17 66.5204 1032.36 96.5004 1032.36 96.5004L1020.66 121.36L1139.58 121.54L1142.83 118.25C1142.83 118.25 1144.21 116.97 1148.63 111.85C1153.04 95.0304 1145.69 53.3604 1145.69 53.3604L1145.68 53.3704ZM1136 70.7904L1120.24 103.33C1118.37 107.2 1114.42 109.65 1110.11 109.6L1049.61 109.01C1046.66 108.98 1044.72 105.92 1045.95 103.23L1061.9 68.5904C1063.5 65.1104 1066.98 62.8804 1070.81 62.8804H1131.05C1135.12 62.8804 1137.78 67.1304 1136.01 70.7904H1136Z",
    fill: "#FB8B24"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.97 87.2471L1060.89 96.9462L1063.94 100.333L1086.71 100.564V107.604H1062.33H1054.5V91.2424L1056.46 87.2531L1060.97 87.2471Z",
    fill: "url(#paint14_radial_4490_4426)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.83 78H1061.29L1056.46 87.2585L1060.97 87.2525L1065.83 78Z",
    fill: "url(#paint15_radial_4490_4426)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.62 100.572L1069.1 97.0477C1068.95 96.9008 1068.87 96.7 1068.87 96.4902V78.8244C1068.87 78.3868 1068.52 78.0361 1068.08 78.0361H1066.07C1065.77 78.0361 1065.5 78.204 1065.37 78.4737L1060.97 87.2617C1060.92 87.3696 1060.89 87.4925 1060.89 87.6124V96.9608C1060.89 97.1706 1060.97 97.3684 1061.12 97.5183L1063.95 100.345C1064.09 100.492 1064.29 100.575 1064.5 100.575H1086.71V107.619H1081.06",
    fill: "url(#paint16_radial_4490_4426)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.62 100.572L1069.1 97.0477C1068.95 96.9008 1068.87 96.7 1068.87 96.4902V78.8244C1068.87 78.3868 1068.52 78.0361 1068.08 78.0361H1066.07C1065.77 78.0361 1065.5 78.204 1065.37 78.4737L1060.97 87.2617C1060.92 87.3696 1060.89 87.4925 1060.89 87.6124V96.9608C1060.89 97.1706 1060.97 97.3684 1061.12 97.5183L1063.95 100.345C1064.09 100.492 1064.29 100.575 1064.5 100.575H1086.71V107.619H1081.06",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.29 105.735H1056.66V108.553H1062.29V105.735Z",
    fill: "url(#paint17_radial_4490_4426)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.07 105.735H1075.44V108.553H1081.07V105.735Z",
    fill: "url(#paint18_radial_4490_4426)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M632.42 160.12H584.17V150.37V110.4H632.42V149.8V160.12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M630.23 113.33H587.09V147.69H630.23V113.33Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M588.05 152.08H586.86C586.584 152.08 586.36 152.304 586.36 152.58V153.77C586.36 154.046 586.584 154.27 586.86 154.27H588.05C588.326 154.27 588.55 154.046 588.55 153.77V152.58C588.55 152.304 588.326 152.08 588.05 152.08Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M591.26 152.08H590.07C589.794 152.08 589.57 152.304 589.57 152.58V153.77C589.57 154.046 589.794 154.27 590.07 154.27H591.26C591.536 154.27 591.76 154.046 591.76 153.77V152.58C591.76 152.304 591.536 152.08 591.26 152.08Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M594.46 152.08H593.27C592.994 152.08 592.77 152.304 592.77 152.58V153.77C592.77 154.046 592.994 154.27 593.27 154.27H594.46C594.736 154.27 594.96 154.046 594.96 153.77V152.58C594.96 152.304 594.736 152.08 594.46 152.08Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M597.67 152.08H596.48C596.204 152.08 595.98 152.304 595.98 152.58V153.77C595.98 154.046 596.204 154.27 596.48 154.27H597.67C597.946 154.27 598.17 154.046 598.17 153.77V152.58C598.17 152.304 597.946 152.08 597.67 152.08Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M600.87 152.08H599.68C599.404 152.08 599.18 152.304 599.18 152.58V153.77C599.18 154.046 599.404 154.27 599.68 154.27H600.87C601.146 154.27 601.37 154.046 601.37 153.77V152.58C601.37 152.304 601.146 152.08 600.87 152.08Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M604.08 152.08H602.89C602.614 152.08 602.39 152.304 602.39 152.58V153.77C602.39 154.046 602.614 154.27 602.89 154.27H604.08C604.356 154.27 604.58 154.046 604.58 153.77V152.58C604.58 152.304 604.356 152.08 604.08 152.08Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M607.29 152.08H606.1C605.824 152.08 605.6 152.304 605.6 152.58V153.77C605.6 154.046 605.824 154.27 606.1 154.27H607.29C607.566 154.27 607.79 154.046 607.79 153.77V152.58C607.79 152.304 607.566 152.08 607.29 152.08Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M610.49 152.08H609.3C609.024 152.08 608.8 152.304 608.8 152.58V153.77C608.8 154.046 609.024 154.27 609.3 154.27H610.49C610.766 154.27 610.99 154.046 610.99 153.77V152.58C610.99 152.304 610.766 152.08 610.49 152.08Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M613.7 152.08H612.51C612.234 152.08 612.01 152.304 612.01 152.58V153.77C612.01 154.046 612.234 154.27 612.51 154.27H613.7C613.976 154.27 614.2 154.046 614.2 153.77V152.58C614.2 152.304 613.976 152.08 613.7 152.08Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M616.9 152.08H615.71C615.434 152.08 615.21 152.304 615.21 152.58V153.77C615.21 154.046 615.434 154.27 615.71 154.27H616.9C617.176 154.27 617.4 154.046 617.4 153.77V152.58C617.4 152.304 617.176 152.08 616.9 152.08Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M620.11 152.08H618.92C618.644 152.08 618.42 152.304 618.42 152.58V153.77C618.42 154.046 618.644 154.27 618.92 154.27H620.11C620.386 154.27 620.61 154.046 620.61 153.77V152.58C620.61 152.304 620.386 152.08 620.11 152.08Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M623.31 152.08H622.12C621.844 152.08 621.62 152.304 621.62 152.58V153.77C621.62 154.046 621.844 154.27 622.12 154.27H623.31C623.586 154.27 623.81 154.046 623.81 153.77V152.58C623.81 152.304 623.586 152.08 623.31 152.08Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M626.52 152.08H625.33C625.054 152.08 624.83 152.304 624.83 152.58V153.77C624.83 154.046 625.054 154.27 625.33 154.27H626.52C626.796 154.27 627.02 154.046 627.02 153.77V152.58C627.02 152.304 626.796 152.08 626.52 152.08Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M629.73 152.08H628.54C628.264 152.08 628.04 152.304 628.04 152.58V153.77C628.04 154.046 628.264 154.27 628.54 154.27H629.73C630.006 154.27 630.23 154.046 630.23 153.77V152.58C630.23 152.304 630.006 152.08 629.73 152.08Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M588.05 155H586.86C586.584 155 586.36 155.224 586.36 155.5V156.69C586.36 156.966 586.584 157.19 586.86 157.19H588.05C588.326 157.19 588.55 156.966 588.55 156.69V155.5C588.55 155.224 588.326 155 588.05 155Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M591.26 155H590.07C589.794 155 589.57 155.224 589.57 155.5V156.69C589.57 156.966 589.794 157.19 590.07 157.19H591.26C591.536 157.19 591.76 156.966 591.76 156.69V155.5C591.76 155.224 591.536 155 591.26 155Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M594.46 155H593.27C592.994 155 592.77 155.224 592.77 155.5V156.69C592.77 156.966 592.994 157.19 593.27 157.19H594.46C594.736 157.19 594.96 156.966 594.96 156.69V155.5C594.96 155.224 594.736 155 594.46 155Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M597.67 155H596.48C596.204 155 595.98 155.224 595.98 155.5V156.69C595.98 156.966 596.204 157.19 596.48 157.19H597.67C597.946 157.19 598.17 156.966 598.17 156.69V155.5C598.17 155.224 597.946 155 597.67 155Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M600.87 155H599.68C599.404 155 599.18 155.224 599.18 155.5V156.69C599.18 156.966 599.404 157.19 599.68 157.19H600.87C601.146 157.19 601.37 156.966 601.37 156.69V155.5C601.37 155.224 601.146 155 600.87 155Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M604.08 155H602.89C602.614 155 602.39 155.224 602.39 155.5V156.69C602.39 156.966 602.614 157.19 602.89 157.19H604.08C604.356 157.19 604.58 156.966 604.58 156.69V155.5C604.58 155.224 604.356 155 604.08 155Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M607.29 155H606.1C605.824 155 605.6 155.224 605.6 155.5V156.69C605.6 156.966 605.824 157.19 606.1 157.19H607.29C607.566 157.19 607.79 156.966 607.79 156.69V155.5C607.79 155.224 607.566 155 607.29 155Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M610.49 155H609.3C609.024 155 608.8 155.224 608.8 155.5V156.69C608.8 156.966 609.024 157.19 609.3 157.19H610.49C610.766 157.19 610.99 156.966 610.99 156.69V155.5C610.99 155.224 610.766 155 610.49 155Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M613.7 155H612.51C612.234 155 612.01 155.224 612.01 155.5V156.69C612.01 156.966 612.234 157.19 612.51 157.19H613.7C613.976 157.19 614.2 156.966 614.2 156.69V155.5C614.2 155.224 613.976 155 613.7 155Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M616.9 155H615.71C615.434 155 615.21 155.224 615.21 155.5V156.69C615.21 156.966 615.434 157.19 615.71 157.19H616.9C617.176 157.19 617.4 156.966 617.4 156.69V155.5C617.4 155.224 617.176 155 616.9 155Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M620.11 155H618.92C618.644 155 618.42 155.224 618.42 155.5V156.69C618.42 156.966 618.644 157.19 618.92 157.19H620.11C620.386 157.19 620.61 156.966 620.61 156.69V155.5C620.61 155.224 620.386 155 620.11 155Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M623.31 155H622.12C621.844 155 621.62 155.224 621.62 155.5V156.69C621.62 156.966 621.844 157.19 622.12 157.19H623.31C623.586 157.19 623.81 156.966 623.81 156.69V155.5C623.81 155.224 623.586 155 623.31 155Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M626.52 155H625.33C625.054 155 624.83 155.224 624.83 155.5V156.69C624.83 156.966 625.054 157.19 625.33 157.19H626.52C626.796 157.19 627.02 156.966 627.02 156.69V155.5C627.02 155.224 626.796 155 626.52 155Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M629.73 155H628.54C628.264 155 628.04 155.224 628.04 155.5V156.69C628.04 156.966 628.264 157.19 628.54 157.19H629.73C630.006 157.19 630.23 156.966 630.23 156.69V155.5C630.23 155.224 630.006 155 629.73 155Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M584.17 149.931H632.42",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M552.36 44.2305H474.86V221.9H552.36V44.2305Z",
    stroke: "#52514E",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M470.36 44.2305H392.86V221.9H470.36V44.2305Z",
    stroke: "#52514E",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.5 50.5H335.73V213.5H385.5V50.5Z",
    stroke: "#52514E",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.5 50.5H275.5V213.5H329.5V50.5Z",
    stroke: "#52514E",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M549.07 46.79H478.15V218.61H549.07V46.79Z",
    fill: "#FFF6DF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M467.92 46.79H396.27V218.61H467.92V46.79Z",
    fill: "#FFF6DF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M381.64 55.5703H339.97V208.38H381.64V55.5703Z",
    fill: "#FFF6DF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323.89 55.5703H280.02V208.38H323.89V55.5703Z",
    fill: "#FFF6DF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M662.5 124H653.5V130H662.5V124Z",
    fill: "#231F20",
    stroke: "#FB8B24",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4490_4426",
    x1: 185.262,
    y1: 182.23,
    x2: 238.162,
    y2: 182.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A97C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4490_4426",
    x1: 753.97,
    y1: 135.081,
    x2: 781.76,
    y2: 135.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4490_4426",
    x1: 666.05,
    y1: 110.77,
    x2: 972.76,
    y2: 110.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4490_4426",
    x1: 963.08,
    y1: 118.261,
    x2: 990.86,
    y2: 118.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4490_4426",
    x1: 980.44,
    y1: 73.5001,
    x2: 983.15,
    y2: 73.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4490_4426",
    x1: 980.44,
    y1: 93.9904,
    x2: 1015.02,
    y2: 93.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4490_4426",
    x1: 1021.38,
    y1: 83.7101,
    x2: 976.79,
    y2: 83.7101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4490_4426",
    x1: 983.15,
    y1: 73.4404,
    x2: 1017.73,
    y2: 73.4404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4490_4426",
    x1: 1015.02,
    y1: 93.9308,
    x2: 1017.73,
    y2: 93.9308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4490_4426",
    x1: 813.128,
    y1: 117.698,
    x2: 812.603,
    y2: 130.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DCDAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4490_4426",
    x1: 864.19,
    y1: 108.57,
    x2: 902.94,
    y2: 108.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4490_4426",
    x1: 864.19,
    y1: 141.471,
    x2: 902.94,
    y2: 141.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4490_4426",
    x1: 862.73,
    y1: 125.02,
    x2: 901.48,
    y2: 125.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DCDAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4490_4426",
    x1: 973.13,
    y1: 84.0801,
    x2: 977.52,
    y2: 84.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DCDAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_4490_4426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1070.6 97.4257) scale(13.4697 13.4697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4490_4426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1061.15 82.6278) scale(4.65772 4.65773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_4490_4426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1073.8 92.8216) scale(13.8833 13.8833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_4490_4426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1059.48 107.144) scale(2.22696 2.22696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_4490_4426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1078.26 107.144) scale(2.22696 2.22696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4490_4426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237.35,
    height: 274.91,
    fill: "white",
    transform: "translate(0.812134 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyPetMachine);
export default __webpack_public_path__ + "static/media/HyPETMachine.e4ea4510ba59928accde3afbba1d808e.svg";
export { ForwardRef as ReactComponent };